/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Role Performer Types - Subset needed for ClassifierService
 */
export enum RolePerformerType {
    OnCameraPrincipal = 'On Camera Principal',
    OffCameraPrincipal = 'Off Camera Principal',
    Extra = 'Extra',
    Radio = 'Radio',
    RadioGroup = 'Radio Group',
    AFM = 'American Federation Of Musicians',
    OnCameraGroup = 'On Camera Group',
    OnCameraGroupContractor = 'On Camera Group Contractor (1-2)',
    OnCameraGroupContractor3To5 = 'On Camera Group Contractor (3-5)',
    OnCameraGroupContractor6To8 = 'On Camera Group Contractor (6-8)',
    OnCameraGroupContractor9Plus = 'On Camera Group Contractor (9+)',
    OffCameraGroup = 'Off Camera Group',
    OffCameraGroupContractor = 'Off Camera Group Contractor (1-2)',
    OffCameraGroupContractor3To5 = 'Off Camera Group Contractor (3-5)',
    OffCameraGroupContractor6To8 = 'Off Camera Group Contractor (6-8)',
    OffCameraGroupContractor9Plus = 'Off Camera Group Contractor (9+)',
}
